import { isDisposable } from '@tencent/dispose-tree';
/**
 * 在依赖注入框架中注入ProxyValue以支持延迟初始化
 */
export class ProxyValue {
    /**
     * @param executor 模块的构造方法，用于创建模块的实例
     */
    constructor(executor) {
        this.didRun = false;
        this.executor = () => {
            try {
                this.innerValue = executor();
            }
            catch (err) {
                this.innerError = err;
            }
            finally {
                this.didRun = true;
            }
        };
    }
    /**
     *  获取模块的实例，如果没有实例则调用_executor创建新实例
     */
    get value() {
        if (!this.didRun) {
            this.executor();
        }
        if (this.innerError) {
            throw this.innerError;
        }
        return this.innerValue;
    }
    /**
     * 清理ProxyValue缓存的实例
     * @param trace 用于跟踪清理调用链的trace日志
     */
    dispose(trace) {
        // 如果_value需要清理，则调用_value的dispose
        if (this.innerValue && isDisposable(this.innerValue)) {
            this.innerValue.dispose(trace);
        }
    }
}
//# sourceMappingURL=proxy-value.js.map